
import qs from 'qs'
export default
    name: "compare-button"
    props: ['bibs', 'global']

    computed:
        qstring: ->
            qs.stringify({bibs: @bibs}, { arrayFormat: 'brackets', encodeValuesOnly: true, addQueryPrefix: true})
    methods:
        compare: ->
            path = if @global then '/compare_global' else '/compare'
            document.location.href = document.location.pathname + path + @qstring
            return

